import React from 'react'
import { Tab } from 'react-bootstrap';

const TabComponent = ({ title, eventKey, children }) => <Tab eventKey={eventKey} title={title}>{children}</Tab>

export default TabComponent;
